import * as React from "react"
const SvgFile = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6 22.571q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 20.57v-16q0-.824.588-1.412A1.93 1.93 0 0 1 6 2.57h7.175a1.98 1.98 0 0 1 1.4.575l4.85 4.85a1.98 1.98 0 0 1 .575 1.4V20.57a1.93 1.93 0 0 1-.587 1.413A1.93 1.93 0 0 1 18 22.57H6Zm7-14v-4H6v16h12v-11h-4a.97.97 0 0 1-.713-.287A.97.97 0 0 1 13 8.57Z" />
  </svg>
)
export default SvgFile
